import type { DeletionOutcome } from '@/queries/account/delete-account'
let pending = false
let result: DeletionOutcome | undefined
export const isDeletionPending = () => pending
export const setDeletionPending = (value: boolean) => { pending = value }
export const setDeletionResult = (value: DeletionOutcome) => { result = value }
export const consumeDeletionResult = () => { const value = result; result = undefined; return value }
